module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/six.8f0dc31c.jpg";